import { Component, HostListener, Output, EventEmitter } from '@angular/core';
import { MapControlService } from '@commons/services/map/control/map-control.serivce';

@Component({
    selector: 'tk-vehicle-list-full-expand',
    templateUrl: './vehicle-list-full-expand.component.html',
    styleUrls: ['./vehicle-list-full-expand.component.less']
})
export class VehicleListFullExpandComponent {

    @Output() public dragStart = new EventEmitter<PointerEvent>();
    @Output() public dragMove = new EventEmitter<PointerEvent>();
    @Output() public dragEnd = new EventEmitter<PointerEvent>();


    private dragging = false;

    @HostListener('pointerdown', ['$event'])
    onPointerDown(event: PointerEvent): void {
        this.dragging = true;
        this.dragStart.emit(event);
    }

    @HostListener('document:pointermove', ['$event'])
    onPointerMove(event: PointerEvent): void {
        if (!this.dragging) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();

        const val = Math.floor(event.clientY);
        this.$mapControlService.resize(val);
        this.dragMove.emit(event);

        return;
    }

    @HostListener('document:pointerup', ['$event'])
    onPointerUp(event: PointerEvent): void {
        if (!this.dragging) {
            return;
        }

        this.dragging = false;
        this.dragEnd.emit(event);
    }

    constructor(private $mapControlService: MapControlService) { }

}
